<template>
  <div class="container-fluid">
    <dashboard-verify-email-alert
      v-if="$userIsUnverified"/>

    <div class="alert alert-info alert-icon" v-if="$userIsTalent">
      <i class="fa fa-info"></i>
      {{ clientName }} now has a mobile app making it even easier to manage your {{ $t('requests') }}! Download it for iPhone and Android <a target="_blank" :href="mobileLink">here</a>!
    </div>

     <div class="dashboard-block" v-else-if="$userIsTalent && $userIsPending">
      <div class="alert alert-info alert-icon">
        <i class="fa fa-info"></i>

        Your account is pending admin verification.
        You can not submit a {{ $t('booking request') }} until your account is verified.
      </div>
    </div>

    <div v-if="$chatsModuleEnabled" class="dashboard-block">
      <h2 class="has-button">
        Your Inbox
        &ndash;
        {{ lists.active_threads_count }}
      </h2>

      <div class="text-center alert alert-default" v-if="haveNoActiveThreads">
        There are no active chats
      </div>
      <ul v-else class="list-items">
        <thread-list-item
          v-for="thread in activeThreads"
          :key="thread.id"
          :thread="thread"
          :booking="thread.booking"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'threads.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>

    <div class="dashboard-block">
      <h2>
        Your {{ $t('Requests') }}
        <media :query="{minWidth: 437}">
          <small>- (showing {{ requests.length }} of {{ this.lists.requests_count }})</small>
        </media>

      </h2>

      <div class="text-center alert alert-default" v-if="haveNoBookingRequests">
        You have no {{ $t('booking requests') }} pending response.
      </div>
      <ul v-else class="list-items">
        <talent-dashboard-booking-requests-list-item
          v-for="booking in requests"
          :key="booking.id"
          :booking="booking"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'requests.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>

    <div class="dashboard-block">
      <h2>
        Your Bookings
        <small>- (showing {{ bookings.length }} of {{ this.lists.bookings_count }})</small>
      </h2>

      <div class="text-center alert alert-default" v-if="haveNoBookings">
        You have no upcoming Bookings.
      </div>
      <ul v-else class="list-items">
        <talent-dashboard-booking-list-item
          v-for="booking in bookings"
          :key="booking.id"
          :booking="booking"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'bookings.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DashboardVerifyEmailAlert from './DashboardVerifyEmailAlert'
import TalentDashboardBookingRequestsListItem from './TalentDashboardBookingRequestsListItem'
import TalentDashboardBookingListItem from './TalentDashboardBookingListItem'
import ThreadListItem from '../message/ThreadListItem'
import Media from 'vue-media'

export default {
  components: {
    DashboardVerifyEmailAlert,
    TalentDashboardBookingRequestsListItem,
    TalentDashboardBookingListItem,
    ThreadListItem,
    Media
  },

  computed: {
    ...mapState('dashboard', ['lists']),

    activeThreads () {
      return this.lists.active_threads || []
    },

    requests () {
      return this.lists.requests || []
    },

    bookings () {
      return this.lists.bookings || []
    },

    haveNoActiveThreads () {
      return this.lists.active_threads === undefined ||
        this.lists.active_threads.length === 0
    },

    haveNoBookingRequests () {
      return this.lists.requests === undefined ||
        this.lists.requests.length === 0
    },

    haveNoBookings () {
      return this.lists.bookings === undefined ||
        this.lists.bookings.length === 0
    }
  }
}
</script>
